/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * Server, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HttpValidationProblemDetails,
  ProblemDetails,
  ServiceNameDto
} from '../models';

import { customInstance } from '../../../orvalCustomAxiosInstance';
import type { ErrorType } from '../../../orvalCustomAxiosInstance';




/**
 * Get service names from Productive for cost estimation - no pricing information exposed.
 */
export const getApiProductiveServiceNames = (

 signal?: AbortSignal
) => {


      return customInstance<ServiceNameDto[]>(
      {url: `/api/Productive/service-names`, method: 'GET', signal
    },
      );
    }




export const getGetApiProductiveServiceNamesQueryKey = () => {
    return [
    `/api/Productive/service-names`
    ] as const;
    }


export const getGetApiProductiveServiceNamesQueryOptions = <TData = Awaited<ReturnType<typeof getApiProductiveServiceNames>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProductiveServiceNames>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiProductiveServiceNamesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiProductiveServiceNames>>> = ({ signal }) => getApiProductiveServiceNames(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiProductiveServiceNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiProductiveServiceNamesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiProductiveServiceNames>>>
export type GetApiProductiveServiceNamesQueryError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>


export function useGetApiProductiveServiceNames<TData = Awaited<ReturnType<typeof getApiProductiveServiceNames>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProductiveServiceNames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProductiveServiceNames>>,
          TError,
          Awaited<ReturnType<typeof getApiProductiveServiceNames>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProductiveServiceNames<TData = Awaited<ReturnType<typeof getApiProductiveServiceNames>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProductiveServiceNames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProductiveServiceNames>>,
          TError,
          Awaited<ReturnType<typeof getApiProductiveServiceNames>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProductiveServiceNames<TData = Awaited<ReturnType<typeof getApiProductiveServiceNames>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProductiveServiceNames>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiProductiveServiceNames<TData = Awaited<ReturnType<typeof getApiProductiveServiceNames>>, TError = ErrorType<ProblemDetails | HttpValidationProblemDetails | void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProductiveServiceNames>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiProductiveServiceNamesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






